import React, {useState, ChangeEvent, FC} from "react";

type Props = {
  withPreview?: boolean
  onFileSelect?: (file: File | null) => void;
};

export const ImageUpload: FC<Props> = ({ withPreview, onFileSelect }) => {
  const [preview, setPreview] = useState<string | null>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      setPreview(null);
      onFileSelect?.(null);
      return;
    }

    const imageUrl = URL.createObjectURL(file);

    setPreview(imageUrl);
    onFileSelect?.(file);
  };

  return <div className={"flex items-start gap-4"}>
      <div>
        <label htmlFor={'image-input'} className={"px-4 py-2.5 bg-brand-primary text-brand-on-primary text-sm rounded-full cursor-pointer inline-block"}>
          Afbeelding uploaden
        </label>
        <input id={'image-input'} type={"file"} accept={"image/*"} onChange={handleChange} className={"hidden"}/>
      </div>

    {withPreview === true && preview &&
      <div className={"flex h-[120px] w-[120px] items-center justify-center overflow-hidden rounded-xl border border-gray-300 bg-gray-50"}>
        {preview ? <img src={preview} alt={"Preview"} className={"h-full w-full object-cover"}/>
          : <div className={"flex items-center justify-center text-center"}>
            <span className={"text-sm text-gray-500"}>Geen afbeelding geselecteerd</span>
          </div>
        }
      </div>
    }
  </div>
}